import axios from "axios";
import environment from "@/environment";
import { mainStorage } from "@/tools/main-storage.js";
import { useLK } from "@/main.js";

const INTERNAL_PREFIXES = [
  environment.appConfig.baseApiUrl,
  environment.appConfig.secondApiUrl,
  process.env.VUE_APP_MINIFLUX_SERVICE,
  "/sources/",
  "/tags/",
  "/stats/",
].filter(Boolean);

function isMyUrl(url) {
  const lower = url.toLowerCase();
  return INTERNAL_PREFIXES.some((prefix) => lower.indexOf(prefix) === 0);
}

export function axiosInit() {
  axios.interceptors.request.use(async (config) => {
    if (isMyUrl(config.url) && !config.url.includes("/login")) {
      const token = mainStorage.getItem("access_token");
      config.headers.Authorization = "Bearer " + token;
    }
    return config;
  });
  axios.interceptors.response.use(null, (error) => {
    const LKStore = useLK();
    const status = error.response.status;
    if (status === 401 || status === 403 && false) {//TODO
      LKStore.goLogin();
    }
    return error;
  });
}
